import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdColorLens, MdDashboard, MdTitle, MdWeb } from "react-icons/md";

import { SectionKey } from "./types";

interface SectionNavProps {
  activeSection: SectionKey;
  onSectionChange: (section: SectionKey) => void;
}

const SECTION_CONFIG: {
  key: SectionKey;
  icon: React.ReactNode;
}[] = [
  { key: "core", icon: <MdColorLens size={16} /> },
  { key: "browser", icon: <MdWeb size={16} /> },
  { key: "icons", icon: <MdDashboard size={16} /> },
  { key: "text", icon: <MdTitle size={16} /> },
];

export const SectionNav = ({
  activeSection,
  onSectionChange,
}: SectionNavProps) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.75,
        mb: 2.5,
        pb: 2,
        borderBottom: "1px solid",
        borderColor: "grey.100",
      }}
    >
      {SECTION_CONFIG.map(({ key, icon }) => {
        const isActive = activeSection === key;
        return (
          <Button
            key={key}
            onClick={() => onSectionChange(key)}
            startIcon={icon}
            sx={{
              flex: 1,
              py: 1,
              border: "2px solid",
              borderColor: isActive ? "primary.main" : "transparent",
              bgcolor: isActive ? "primary.main" : "grey.100",
              borderRadius: 2,
              color: isActive ? "white" : "text.secondary",
              fontWeight: 500,
              fontSize: "0.75rem",
              textTransform: "none",
              boxShadow: isActive
                ? "0 2px 8px rgba(31, 173, 178, 0.15)"
                : "none",
              "&:hover": {
                bgcolor: isActive ? "primary.dark" : "grey.200",
              },
              "& .MuiButton-startIcon": {
                marginRight: 0.75,
              },
            }}
          >
            {t(`preferences.uiBranding.sectionNav.${key}`)}
          </Button>
        );
      })}
    </Box>
  );
};
